import Vue from 'vue';
import format from 'date-fns/format'
import VueSimpleSpinner from 'vue-simple-spinner'
import { HTTP } from '@/utils/httpCommonUtil';

export default Vue.component('facility-paid-invoice-card', {
  name: 'Invoices',
  props: {
    'week': { type: Object },
    'filters': { type: Array }
  },
  components: {
    VueSimpleSpinner
  },
  data () {
    return {
      loadingInitialData: false,
      cardExpanded: false,
      invoices: [] as any[]
    }
  },
  filters: {
    weekFormat (dateISO: string) {
      return format(dateISO, 'MMMM D');
    }
  },
  async created () {
    await this.expandCard();
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadData();
      }
    },
    async loadData () {
      let showLoadingSpinnerTimeout = setTimeout(() => {
        this.loadingInitialData = true;
      }, 0);
      try {
        const response = await HTTP.get('/api/invoices/paid/facility-contact-user/');
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Invoice Information.");
        }
        this.invoices = response.data.data;
      } catch (err) {
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Invoice Information.'
        });
      }
    },
    goToInvoice (invoiceId: any) {
      this.$router.push({name: 'Invoice', params: {invoiceId: invoiceId} });
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoices/cards/facilityPaidInvoices/FacilityPaidInvoicesCard.ts